
import React from 'react';

import { usePagination } from '_context/PaginationHooks';


export const Pagination = ({pageCount,onChange}) => {
    const [initialPage, setInitialPage] = React.useState(1);
    const [numberOfPages, setNumberOfPages] = React.useState(0);
    const [maxButtons, setMaxButtons] = React.useState(5);
  

    React.useEffect(() => {
        if (!pageCount!==null) {
            setNumberOfPages(pageCount);
        }
      }, [pageCount]);
 
    const {
      activePage,
      visiblePieces,
      goToPage,
    } = usePagination({ initialPage, numberOfPages, maxButtons, onChange });

    const onClick = (pageNumber) => {
        goToPage(pageNumber);
        onChange(pageNumber-1,true);
    }
  
    return (
    
        <div className="pagenation">
          {visiblePieces.map((visiblePiece, index) => {
            const key = `${visiblePiece.type}-${index}`;
  
            if (visiblePiece.type === 'ellipsis') {
              return <span key={key}>...</span>;
            }
  
            const { pageNumber } = visiblePiece;
            //const onClick = () => goToPage(pageNumber);
  
            if (visiblePiece.type === 'page-number') {
              const isActive = pageNumber === activePage;
              const className = isActive ? 'primary' : '';

              return <a key={key} onClick={()=>onClick(pageNumber)} className={className}>{pageNumber}</a>
            }
            let clsName = "btnsSch " + (visiblePiece.type === 'next' ? 'next' : 'prev') + (visiblePiece.isDisabled?" disabled":"");
            return <a key={key} className={clsName} onClick={()=>onClick(pageNumber)}>{visiblePiece.type === 'next' ? '다음' : '이전'}</a>

          })}
        </div>

    );
}